import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { ReplacementDataMediumSource } from '../models';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class ReplacementDataMediumSourcesService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readReplacementDataMediumSource(
    iri: string
  ): Observable<ReplacementDataMediumSource> {
    return this.rolesService.userHasRoleFilter<ReplacementDataMediumSource>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_SOURCE_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readReplacementDataMediumSources(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_SOURCE_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/replacement_data_medium_sources`)
    );
  }
}
